import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    OPEN_UNIT_TRUST_ACCOUNT_FEATURE_KEY,
    SAVINGS_ACCOUNT_PARAMS_FEATURE_KEY,
    UNIT_TRUST_ACCOUNT_ACCOUNT_TRANSACTIONS_KEY,
    UNIT_TRUST_ACCOUNT_ACCOUNTS_KEY,
    UNIT_TRUST_ACCOUNT_STATEMENT_FEATURE_KEY,
    UNIT_TRUST_FACT_SHEETS_KEY
} from './reducers';

export const selectUnitTrustAccountStatementState = createFeatureSelector<any>(UNIT_TRUST_ACCOUNT_STATEMENT_FEATURE_KEY);
export const selectUnitTrustAccountStatement = createSelector(
    selectUnitTrustAccountStatementState,
    (state: any) => state?.statement
);

// Selectors for unit trust accounts
export const selectUnitTrustAccountsState = createFeatureSelector<any>(UNIT_TRUST_ACCOUNT_ACCOUNTS_KEY);
export const selectUnitTrustAccounts = createSelector(
    selectUnitTrustAccountsState,
    (state: any) => state?.accounts
);

export const selectUnitTrustAccountsError = createSelector(
    selectUnitTrustAccountsState,
    (state: any) => state?.error
);

// Selectors for unit trust account transactions
export const selectUnitTrustAccountTransactionsState = createFeatureSelector<any>(UNIT_TRUST_ACCOUNT_ACCOUNT_TRANSACTIONS_KEY);
export const selectUnitTrustAccountTransactions = createSelector(
    selectUnitTrustAccountTransactionsState,
    (state: any) => state?.transactions
);

export const selectUnitTrustAccountTransactionsError = createSelector(
    selectUnitTrustAccountTransactionsState,
    (state: any) => state?.error
);

/**
 * Get Savings Account Params
 */
export const selectSavingsAccountParamsState = createFeatureSelector<any>(SAVINGS_ACCOUNT_PARAMS_FEATURE_KEY);
export const selectSavingsAccountParams = createSelector(
    selectSavingsAccountParamsState,
    (state: any) => state?.savingsAccountParams
);

/**
 * Get Unit Trust Fact Sheets
 */
export const selectUnitTrustFactSheetsState = createFeatureSelector<any>(UNIT_TRUST_FACT_SHEETS_KEY);
export const selectUnitTrustFactSheets = createSelector(
    selectUnitTrustFactSheetsState,
    (state: any) => state?.factSheets
);

export const selectUnitTrustFactSheetsError = createSelector(
    selectUnitTrustFactSheetsState,
    (state: any) => state?.error
);

export const selectUnitTrustFactSheetsLoading = createSelector(
    selectUnitTrustFactSheetsState,
    (state: any) => state?.loading
);

/**
 * Open Unit Trust Account
 */
export const selectOpenUnitTrustAccountState = createFeatureSelector<any>(OPEN_UNIT_TRUST_ACCOUNT_FEATURE_KEY);
export const selectOpenUnitTrustAccountDetails = createSelector(
    selectOpenUnitTrustAccountState,
    (state: any) => state?.accountDetails
);

export const selectOpenUnitTrustAccountError = createSelector(
    selectOpenUnitTrustAccountState,
    (state: any) => state?.error
);
